var React = require('react');

function Shield (props) {
    return React.createElement("svg",props,React.createElement("g",{"clipPath":"url(#a)","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M13.253 20.601c-.408.155-.826.288-1.252.399A12 12 0 0 1 3.5 6 12 12 0 0 0 12 3a12 12 0 0 0 8.5 3 12 12 0 0 1-.19 7.357M22 22l-5-5M17 22l5-5"})));
}

Shield.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Shield;

Shield.default = Shield;
